/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit"; 
import { getFunctions, httpsCallable } from "firebase/functions";

import { getAuth, signOut } from 'firebase/auth';


export const logout = createAsyncThunk('user/logout', async (page, { rejectWithValue }) => {
    try {
        const auth = getAuth();
        await signOut(auth); // Sign out the user
        return true;  
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getUserInfo = createAsyncThunk('user/getUserMe', async (_, { rejectWithValue }) => {
    try {
      const functions = getFunctions();
      const auth = getAuth();
  
      // Use a promise to handle async operations
      return new Promise((resolve, reject) => {
        auth.onAuthStateChanged((user) => {
          if (user) {
            const callableReturnMessage = httpsCallable(functions, 'getAdminProfile');
            callableReturnMessage({ userId: user.uid }).then((response) => {
              console.log('response user', response.data);
              if (response && response.data && Object.keys(response.data).length > 0) {
                resolve(response.data); // Resolve with user data
              } else {
                console.log('NOT user', response.data);
                resolve(null); // Resolve with null for empty data
              }
            }).catch((error) => {
              reject(error.message); // Reject with error message
            });
          } else {
            reject('User not authenticated'); // Reject if user not authenticated
          }
        });
      });
    } catch (error) {
      return rejectWithValue(error.message); // Reject with error message using rejectWithValue
    }
  });